import { Typography } from "@material-tailwind/react";
import { Button } from "@material-tailwind/react";
import './Footer.css';
import { useNavigate } from "react-router-dom";

const LINKS = [
  {
    title: "Global",
    items: [
      { name: "Work", path: "/work" },
      { name: "About Us", path: "/about-us" },
    ],
  },
  {
    title: "Services",
    items: [
      { name: "Product Scope", path: "/product-scope" },
      { name: "UX/UI Design", path: "/ui-ux" },
      { name: "MVP Builder", path: "/mvp-builder" },
      { name: "Dedicated Teams", path: "/dedicated-teams" },
      { name: "Custom Software Development", path: "/custom-software-development" },
    ],
  },
  {
    title: "Technology",
    items: [{ name: "Tech", path: "/tech" }],
  },
];

const currentYear = new Date().getFullYear();

const Footer = () => {
  const navigate = useNavigate();

  return (
    <section className="relative">
      <footer className="relative ">
        <div className="mx-auto w-full flex flex-col md:flex-row bg-[#202730] pl-2 mt-2 sm:pl-5 md:pl-10 lg:pl-20 sm:mt-6 md:mt-12 lg:mt-24 py-10 overflow-hidden">
          {/* Title and Call Button */}
          <div className="mb-8 md:mb-0 md:w-1/2">
            <h1 className="text-3xl sm:text-4xl md:text-5xl text-white font-bold font-poppins mb-4 sm:mb-8 leading-snug sm:leading-tight">
              Let’s talk about
              <br />
              your project
            </h1>
            <Button
              variant="outlined"
              className="border-2 border-[#96226E] px-6 py-2 font-poppins font-bold text-white text-sm rounded-full sm:text-md sm:px-8 sm:py-3 hover:bg-[#96226E] transition duration-300"
              onClick={() => navigate("/start-a-project")}
            >
              Schedule a Call
            </Button>
          </div>

          <div className="flex flex-col items-center md:items-start justify-between gap-10">
            <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-5 w-full">
              <div className="w-48 md:w-56 lg:w-96">
                <img src="/heidelberg1.svg" alt="codify" className="w-full h-auto" />
              </div>
              <div className="text-white text-sm sm:text-md md:text-lg leading-relaxed flex-1 w-full text-center md:text-left md:mt-5">
                <h2 className="font-bold text-md font-poppins md:text-md">HEIDELBERG</h2>
                <p className="font-poppins">Address: Lessingstraße 18<br />69221 Dossenheim</p>
                <p className="font-poppins">
                  Phone: <span className="text-[#96226E] font-poppins">+351 930944995</span>
                </p>
              </div>
            </div>

            <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-5 w-full">
              <div className="w-48 md:w-56 lg:w-96">
                <img src="/damascus2.svg" alt="codify" className="w-full h-auto" />
              </div>
              <div className="text-white text-sm sm:text-md md:text-lg leading-relaxed flex-1 w-full text-center md:text-left md:mt-5">
                <h2 className="font-bold text-md font-poppins md:text-md">DAMASCUS</h2>
                <p className="font-poppins ">Address: Al Abbasid Square</p>
                <p className="font-poppins">
                  Phone: <span className="text-[#96226E] font-poppins">+963 953793975</span>
                </p>
              </div>
            </div>
          </div>

        </div>
        <div className="mx-auto w-full bg-[#141C25] py-8 overflow-hidden">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 px-6">
            <Typography variant="h5" className="mb-6 text-2xl font-poppins text-white">
              Codify
            </Typography>
            <div className="grid grid-cols-3 gap-4">
              {LINKS.map(({ title, items }) => (
                <ul key={title}>
                  <Typography
                    variant="small"
                    color="white"
                    className="mb-3 font-medium text-lg font-poppins text-white "
                  >
                    {title}
                  </Typography>
                  {items.map((link) => (
                    <li key={link.name}>
                      <Typography
                        as="span"
                        className="py-1.5 font-normal text-gray-400 hover:text-[#96226E] transition-colors cursor-pointer"
                        onClick={() => link.path && navigate(link.path)}
                      >
                        {link.name}
                      </Typography>
                    </li>
                  ))}
                </ul>
              ))}
            </div>
          </div>
          <div className="mt-12 flex flex-col items-center justify-center border-t border-gray-700 py-6 md:flex-row md:justify-between px-6">
            <Typography
              variant="small"
              className="mb-4 text-center text-gray-400 md:mb-0"
            >
              &copy; {currentYear} <a href="https://material-tailwind.com/" className="text-gray-200 hover:text-gray-100">Codify</a>. All Rights Reserved.
            </Typography>
          </div>
        </div>
      </footer>
    </section>
  );
};

export default Footer;
